import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './MapPin.css';

interface IMapPinProps {
  image: string | null;
}

export function MapPin({ image }: IMapPinProps) {
  return (
    <span className={clsx(styles['pin'], { [styles['pin--image']]: image })}>
      {image && <span style={{ backgroundImage: `url('${image}')` }} />}
    </span>
  );
}
